module.exports = __webpack_public_path__ + "static/media/vector-right.2916a1ac.svg";